import { useEffect } from "react";

export function useHashFragment(element = "", offset = -80, trigger = true) {
  useEffect(() => {
    const scrollToHashElement = () => {
      const elementToScroll = document.getElementById(element);
      if (!elementToScroll) return;
      let y =
        elementToScroll.getBoundingClientRect().top +
        window.pageYOffset +
        offset;
      /* elementToScroll.scrollIntoView({
        block: "start",
        behavior: "smooth"
      }); */
      window.scrollTo({
        top: y,
        behavior: "smooth",
      });
    };

    if (!trigger) return;

    scrollToHashElement();
    window.addEventListener("hashchange", scrollToHashElement);
    return window.removeEventListener("hashchange", scrollToHashElement);
  }, [trigger]);
}
